// extracted by mini-css-extract-plugin
export default {"card":"QuoteSection_card__15DiQ","column":"QuoteSection_column__-xaIM","photo":"QuoteSection_photo__Evpxa","name":"QuoteSection_name__VUnrS"};